import React, { useEffect, useState, useContext } from "react";
import LotteryItem from "../Profile/Lottery/LotteryItem";
import { base_url } from "../Api/Api";
import Skltn from "./skltnAward";
import Popup from "../Common/Popup";
import Button from "@material-ui/core/Button";
import { AppContext } from "../../layout/AppContext";
import { Loader } from "../Common/Loader";
const Awards = (props) => {
  const { contextStore, setContextStore } = useContext(AppContext);
  const [state, setState] = useState({
    timstamp: false,
    data: [],
    contentStatus: false,
    statusPopup: false,
    count: 1,
    user_score: null,
    error: {
      id: 0,
      message: "",
    },
  });
  const [loading, setLoading] = useState(true);
  const [statusCountPopup, setStatusCountPopup] = useState(false);
  const [requiredScore, setRequiredScore] = useState(null);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    updateData();
  }, []);

  const updateData = () => {
    setLoader(true);
    // setStatusCountPopup(false)
    setState({
      ...state,
      data: [],
      statusPopup: false,
      contentStatus: true,
    });

    base_url
      .get("lotteries")
      .then((response) => {
        setState({
          ...state,
          data: response.data.lotteries,
          contentStatus: response.data.lotteries.length !== 0,
          statusPopup: false,
          verficcationText: "با موفقیت در قرعه کشی شرکت کردید.",
          user_score: response.data.lotteries[0].user_score,
        });
        setLoader(false);
        setContextStore({
          ...contextStore,
          userScore: response.data.lotteries[0].user_score || 0,
        });
      })
      .catch((error) => {
        if (error.response != undefined) {
          if (error.response.status == 401) {
            props.history.push(`/Entrance`);
            localStorage.clear();
            window.location.reload();
          }
          setState({
            ...state,
            statusPopup: false,
          });
        }
        setLoader(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const showPopup = (status) => {
    setState({
      ...state,
      statusPopup: status,
    });
  };
  const showCountPopup = (status) => {
    setStatusCountPopup(status);
  };

  const lottery = () => {
    setStatusCountPopup(false);
    setLoader(true);
    const Data = {
      lottery_id: localStorage.getItem("lotteryId"),
      count: state.count,
    };

    base_url
      .post("lottery_register", Data)
      .then((response) => {
        // showCountPopup(false)
        setLoader(false);
        if (response.data.status) {
          setState({
            ...state,
            canRegister: false,
          });
        }
        showPopup(true);
      })
      .catch((error) => {
        console.log(error.response.data.message);
        if (error.response.status === 422) {
          setState((perv) => ({
            ...perv,
            error: {
              id: Data.lottery_id,
              message: error.response.data.message,
            },
          }));
        }
        if (error.response != undefined) {
          if (error.response.status == 401) {
            props.history.push(`/Entrance`);
          }
          setLoader(false);
        }
      });
  };
  const countHandler = (type) => {
    let available = state.user_score / requiredScore;
    if (type === "plus") {
      if (state.count < available) {
        setState({ ...state, count: state.count + 1 });
      }
    } else if (type === "minus") {
      if (state.count > 1) {
        setState({ ...state, count: state.count - 1 });
      }
    }
  };

  return (
    <div className="balloting">
      <Popup active={state.statusPopup} class="award-popup">
        <span>{state.verficcationText}</span>
        <div className="btn-base btn-black btn-sircle">
          <Button variant="contained" onClick={updateData}>
            تایید
          </Button>
        </div>
      </Popup>
      <Popup active={statusCountPopup} class="award-popup">
        <h4>شرکت در قرعه کشی</h4>
        <p>
          تعداد دفعات شرکت در قرعه‌کشی را انتخاب کنید. <br /> هرچه تعداد دفعات
          شرکت در قرعه‌کشی بیشتر باش، شانس شما برای برنده شدن بیشتر خواهد بود
        </p>
        <div className="count-handler">
          <button onClick={(e) => countHandler("plus")}> + </button>
          <span>{state.count}</span>
          <button className="minus" onClick={(e) => countHandler("minus")}>
            {" "}
            -{" "}
          </button>
        </div>
        <div className="row-scors">
          <div className="scrs">
            <span>امتیاز شما : </span>
            <b>{state.user_score}</b>
          </div>
          <div className="scrs">
            <span>حداقل امتیاز : </span>
            <b>{requiredScore}</b>
          </div>
        </div>
        <div className="btns">
          <Button variant="contained" onClick={() => lottery()}>
            تایید
          </Button>
          <Button
            className="cancle"
            variant="contained"
            onClick={() => setStatusCountPopup(false)}
          >
            لغو
          </Button>
        </div>
      </Popup>
      <div className="contain">
        <div className="lottery-body">
          {loading ? (
            <Skltn />
          ) : state.data.length ? (
            state.data.map((info, info_index) => (
              <LotteryItem
                key={info.id ? info.id : info_index}
                data={info}
                error={state.error}
                showPopup={showPopup}
                showCountPopup={showCountPopup}
                requiredScore={(score) => setRequiredScore(score)}
              />
            ))
          ) : (
            <span className="no-content">موردی برای نمایش وجود ندارد.</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default Awards;
